import { useQuery } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import { QUERY_STALE_TIME } from "utils/constants";
import queryFn from "ApiLayer/Reports/Recommendations/queryAnnualEmissionSavingsByMeasureChart";

export const useAnnualEmissionSavingsByMeasureChart = (filtersetUid: string) => {
    const accessToken = useAccessToken();

    return useQuery({
        queryKey: ["annualEmissionSavingsByMeasureChart", filtersetUid],
        queryFn: async () => queryFn(accessToken, { reportFiltersetUid: filtersetUid }),
        staleTime: QUERY_STALE_TIME,
    });
};
